export * from './envConfigAdapter/index.js';
